const CreateMarkup = (markup) => {
  return { __html: markup }
}

export default CreateMarkup
